import { useForm } from "react-hook-form";
import { Button, Card, Form, Input, message, Space ,Spin} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Watermark } from "antd";
import { useNavigate, useLocation } from "react-router-dom";


const ForgotPasswordButton = ({ username }) => {
  const navigate = useNavigate();
  const handleForgotPasswordClick = () => {
    navigate(`/forgot-password?username=${username}`);
  };

  return (
    <Form.Item>
      <Button type="link" onClick={handleForgotPasswordClick}>
        Passwort vergessen?
      </Button>
    </Form.Item>
  );
};

export const Login = ({ isModal }) => {
  const navigate = useNavigate();
  const defaultButtonRef = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const { login ,user} = LayoutData();
  const [username, setUsername] = useState(queryParams.get("username"));
  const [toLink, setToLink] = useState(queryParams.get("to"));
  const {
    formState: { errors },
  } = useForm();
  useEffect(() => {
    if (defaultButtonRef.current) {
      defaultButtonRef.current.focus();
    }
  }, []); // Leere Abhängigkeitsliste, um sicherzustellen, dass der Effekt nur einmal ausgeführt wird

  const onFinish = async (daten) => {
    setLoading(true);
    let status = await login(daten.username, daten.password);
    setLoading(false);
    switch (status) {
      case 200:
        message.success("Anmeldung erfolgreich");
        navigate(`/${toLink||""}`); 
        break;
      case 401:
        message.error("Name und Passwort falsch");
        message.info("Probiere es nochmals");
        break;
      case 500:
        message.error("Interner Server Fehler");
        navigate("/apitest");
        break;
      default:
        message.error("Fehler " + status);
        navigate("/apitest");
        break;
    }
  };
  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };
  return (
    <>
      <div className="page">
        <Watermark content="Login">
          <center>
            <Space direction="vertical" size={12}>
              <Card
                title="Bitte mit EMail und Passwort anmelden"
                style={{
                  maxWidth: 400,
                  marginTop: 25,
                }}
              >
                <Form layout="vertical" onFinish={onFinish}>
                  <Form.Item                  
                    label="Username:"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "Bitte Benutzernamen als Email eingeben!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Benutzername als EMail"
                      defaultValue={username}

                      help={errors.username?.message}
                      validatestatus={errors.username ? "error" : ""}
                      required
                      prefix={<UserOutlined />}
                      onChange={handleUsernameChange}
                    ></Input>
                  </Form.Item>
                  <Form.Item
                    label="Passwort:"
                    name="password"
                    rules={[{ required: true }]}
                  >
                    <Input
                      type="password"
                      prefix={<LockOutlined />}
                      placeholder="Passwort"
                      help={errors.password?.message}
                      validatestatus={errors.password ? "error" : ""}
                      required
                      allowClear={false}
                      disabled={false}
                    ></Input>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      ref={defaultButtonRef}
                    >
                      {loading ? <Spin /> : 'Anmelden'}
                    </Button>
                  </Form.Item>
                  <ForgotPasswordButton username={username} />
                </Form>
              </Card>
            </Space>
          </center>
        </Watermark>
      </div>
    </>
  );
};
// Modal Login

export const LoginModal = () => {
  const [modal2Open, setModal2Open] = useState(true);
  const navigate = useNavigate();
  return (
    <>
      <Modal
        title="Herzlich Willkommen"
        width={400}
        centered
        open={modal2Open}
        cancelText="Schließen"
        onCancel={() => {
          setModal2Open(false);
          navigate("/");
        }}
        onOk={() => setModal2Open(false)}
        okText="-"
        okButtonProps={{ style: { display: "none" } }} // Hier wird der OK-Button ausgeblendet
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Login isModal={true} />
      </Modal>
    </>
  );
};
